import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, Routes, Route, Navigate } from 'react-router-dom';
import { tutorApi, setAuthToken } from '../services/api';
import TutorNavbar from '../components/TutorNavbar';
import TutorTutees from '../components/TutorTutees';
import AdminTutees from '../components/AdminTutees';
import LessonOverview from '../components/LessonOverview';
import MonthlySummary from '../components/MonthlySummary';
import SubmitAttendance from '../components/SubmitAttendance';
import TutorProfile from '../components/TutorProfile';
import TuteeProfile from '../components/TuteeProfile';
import NotificationList from '../components/NotificationList';
import NotificationPreferences from '../components/NotificationPreferences';
import ClaimsManagement from '../components/ClaimsManagement';
import FinanceICInvoiceManagement from '../components/FinanceICInvoiceManagement';
import '../assets/TutorDashboard.css';

const TutorDashboard = () => {
  const [activeTab, setActiveTab] = useState('submit');
  const [user, setUser] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/');
      return;
    }
    setAuthToken(token);
    const userStr = localStorage.getItem('user');
    if (userStr) {
      setUser(JSON.parse(userStr));
    }
  }, [navigate]);

  // Sync activeTab with current route
  useEffect(() => {
    const path = location.pathname;
    if (path.includes('/submit')) {
      setActiveTab('submit');
    } else if (path.includes('/admin-tutees')) {
      setActiveTab('admin-tutees');
    } else if (path.includes('/tutees')) {
      setActiveTab('tutees');
    } else if (path.includes('/lessons') || path.includes('/endorsement')) {
      setActiveTab('lessons');
    } else if (path.includes('/profile')) {
      setActiveTab('profile');
    } else if (path.includes('/claims')) {
      setActiveTab('claims');
    } else if (path.includes('/finance-ic-invoices')) {
      setActiveTab('finance-ic-invoices');
    }
  }, [location.pathname]);

  const handleSelectLessonMonth = (month, year) => {
    navigate(`/tutor/lessons/${year}/${month}`);
  };

  const handleBackToOverview = () => {
    navigate('/tutor/lessons');
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    setAuthToken(null);
    navigate('/');
  };

  return (
    <div className="tutor-dashboard">
      <TutorNavbar
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        user={user}
        onLogout={handleLogout}
      />

      <div className="dashboard-content">
        <Routes>
          <Route path="/" element={<SubmitAttendance />} />
          <Route path="submit" element={<SubmitAttendance />} />
          <Route path="tutees" element={<TutorTutees user={user} />} />
          {user?.isCoFounder && <Route path="admin-tutees" element={<AdminTutees />} />}
          {user?.isCoFounder && <Route path="admin-tutees/:id" element={<TuteeProfile readOnly={true} />} />}
          {/* Lesson overview */}
          <Route path="lessons" element={<LessonOverview onSelectMonth={handleSelectLessonMonth} />} />
          {/* Monthly detail — URL-driven so browser back works */}
          <Route path="lessons/:year/:month" element={<MonthlySummary onBack={handleBackToOverview} />} />
          {/* Legacy endorsement URLs */}
          <Route path="endorsement/:year/:month" element={<MonthlySummary onBack={handleBackToOverview} />} />
          <Route path="profile" element={<TutorProfile />} />
          <Route path="claims" element={<ClaimsManagement />} />
          <Route path="finance-ic-invoices" element={<FinanceICInvoiceManagement user={user} />} />
          <Route path="notifications" element={<NotificationList />} />
          <Route path="preferences" element={<NotificationPreferences />} />
          {/* Catch-all: any unmatched tutor path falls back to the dashboard home
              instead of rendering a blank content area */}
          <Route path="*" element={<Navigate to="/tutor" replace />} />
        </Routes>
      </div>
    </div>
  );
};

export default TutorDashboard;